import { Checkbox, NumberInput, Text, TextInput } from "@gravity-ui/uikit";

import css from "./TemplateEditor.module.scss";
import {
  FALLBACK_MAX_LENGTH,
  MAX_LENGTH_LIMIT,
} from "./TemplatesForm.constants";

interface Props {
  idPrefix: string;
  fallback: string;
  maxLength: number | undefined;
  applyOnlyIfEmpty: boolean;
  applyOnlyIfEmptyLabel: string;
  onUpdateFallback: (next: string) => void;
  onUpdateMaxLength: (next: number | undefined) => void;
  onUpdateApplyOnlyIfEmpty: (next: boolean) => void;
}

// Группа дополнительных полей шаблона: fallback (запасной текст) + maxLength
// (жёсткое усечение) + applyOnlyIfEmpty (применять только если поле пустое).
// Вынесено из TemplateEditor, чтобы render-prop Controller'a не разрастался.
export const TemplateOptionsFields = ({
  idPrefix,
  fallback,
  maxLength,
  applyOnlyIfEmpty,
  applyOnlyIfEmptyLabel,
  onUpdateFallback,
  onUpdateMaxLength,
  onUpdateApplyOnlyIfEmpty,
}: Props) => (
  <>
    <div className={css.row}>
      <div className={css.rowInner}>
        <div className={css.col}>
          <label className={css.fieldLabel} htmlFor={`${idPrefix}-fallback`}>
            Запасной текст
          </label>
          <TextInput
            id={`${idPrefix}-fallback`}
            size="m"
            value={fallback}
            // Жёстко обрезаем длину на фронте, чтобы не дать бэку вернуть 400
            // после клиентского typo — лимит дублируется в class-validator.
            onUpdate={(next) =>
              onUpdateFallback(next.slice(0, FALLBACK_MAX_LENGTH))
            }
            placeholder="Например: Уточняйте у менеджера"
          />
          <Text variant="caption-2" color="hint">
            Подставится, если результат шаблона полностью пуст.
          </Text>
        </div>

        <div className={css.colNarrow}>
          <label className={css.fieldLabel} htmlFor={`${idPrefix}-maxlen`}>
            Макс. длина
          </label>
          <NumberInput
            id={`${idPrefix}-maxlen`}
            size="m"
            value={maxLength ?? null}
            onUpdate={(next) => onUpdateMaxLength(next ?? undefined)}
            min={1}
            max={MAX_LENGTH_LIMIT}
            hiddenControls={false}
            placeholder="без ограничения"
          />
          <Text variant="caption-2" color="hint">
            Лишнее обрежется с «…».
          </Text>
        </div>
      </div>
    </div>

    <Checkbox
      size="m"
      checked={applyOnlyIfEmpty}
      onUpdate={onUpdateApplyOnlyIfEmpty}
    >
      {applyOnlyIfEmptyLabel}
    </Checkbox>
  </>
);
